import { User } from '@warema/shared/models';
import { EventType } from 'angular-oauth2-oidc';

export interface Token {
    token: string;
    validTill: number;
}

export interface PasswordValidationResult {
    errorTexts: Array<PasswordValidationRule>;
}

export interface SsoUserInfo {
    info: {
        sub: string;
    };
}

export interface PasswordValidationRule {
    error: string;
    valid: boolean;
}

export type CustomCheck = (userData: User | null) => boolean;

export type CurrentAuthenticationState =
    'initializing' | 'unauthenticated' | 'userLoading' | 'userError' | 'authenticationComplete';

export class OAuthError extends Error {
    public type: EventType;

    constructor(message: string, type: EventType) {
        super(message);
        this.name = 'OAuthError';
        this.type = type;
    }
}
